"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyTemplate = applyTemplate;
const lodash_1 = __importDefault(require("lodash"));
// Matches all "%{placeholder}" over multiple lines with a capture group on the placeholder name.
const placeholderMatcher = /(?:%{)(.*?)(?:})/gm;
function applyTemplate(message, options = {}) {
    return message.replace(placeholderMatcher, buildReplacer(options));
}
function buildReplacer(options) {
    return (match, optionName) => {
        const option = options[optionName];
        if (typeof option !== 'undefined') {
            return lodash_1.default.toString(option);
        }
        return `** missing ${optionName} value **`;
    };
}
